module.exports = __webpack_public_path__ + "42dbd74e1af758a6ad275e4ee9ced640.jpg";